import DefaultLayout from "../components/layout/DefaultLayout";
import { useSelector, useDispatch } from "react-redux";
import { useRef, useState } from "react";
import Form from "react-bootstrap/Form";
import { Button } from "react-bootstrap";
import ReCAPTCHA from "react-google-recaptcha";
import { userActions } from "../store/userSlice";
import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { updateContactInfo } from "../actions/users";

function UpdateLessee() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const recaptcha = useRef();
  const email = useSelector((state) => state.user.register.email);
  const cellphone = useSelector((state) => state.user.register.cellphone);
  const idNumber = useSelector((state) => state.user.register.nationalIdNumber);
  const contractNumber = useSelector(
    (state) => state.user.register.contractNumber
  );
  const redirectTo = useSelector((state) => state.user.redirectTo);

  const onEmail = (event) => {
    dispatch(userActions.setRegisterEmail(event.target.value));
  };
  const onCellphone = (event) => {
    dispatch(userActions.setRegisterCellphone(event.target.value));
  };
  const onRecaptcha = () => {};
  const continueHandler = () => {
    dispatch(updateContactInfo(email, cellphone, idNumber, contractNumber));
  };

  useEffect(() => {
    if (redirectTo) {
      navigate(redirectTo);
    }
  }, [redirectTo]);

  const body = () => {
    return (
      <div>
        <section className="slice sct-color-1">
          <div className="container relative">
            <div className="row">
              <div className="col-12">
                <div className="py-5 text-center">
                  <h1 className="heading heading-1 strong-400 text-normal">
                    Actualiza tu informacion de contacto
                  </h1>

                  <span className="clearfix"></span>

                  <div>
                    <Form>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInputEmail"
                      >
                        <Form.Label>Email</Form.Label>
                        <Form.Control
                          type="string"
                          placeholder=""
                          onChange={onEmail}
                          defaultValue={email}
                        />
                      </Form.Group>
                      <Form.Group
                        className="mb-3"
                        controlId="exampleForm.ControlInputName"
                      >
                        <Form.Label>Numero de celular</Form.Label>
                        <Form.Control
                          type="string"
                          placeholder=""
                          onChange={onCellphone}
                          defaultValue={cellphone}
                        />
                      </Form.Group>
                      {/* <ReCAPTCHA
                        onChange={onRecaptcha}
                        sitekey={process.env.REACT_APP_SITE_KEY}
                      />*/}
                      <Button
                        disabled={!email || !cellphone}
                        onClick={continueHandler}
                      >
                        Continuar
                      </Button>
                    </Form>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    );
  };

  return (
    <div>
      <div>
        <DefaultLayout body={body()} />
      </div>
    </div>
  );
}

export default UpdateLessee;
